import React, { Component, PropTypes } from 'react'
import Toggle from 'material-ui/Toggle';
import {ListItem} from 'material-ui/List';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import IconButton from 'material-ui/IconButton';
import {red500} from 'material-ui/styles/colors';

export default class Query extends Component {
  render() {
    const { toggleQuery, deleteQuery, query, active } = this.props
    return (
			<ListItem primaryText={query} leftCheckbox={
				<Toggle defaultToggled={active} onToggle={(eventTarget, isChecked) => toggleQuery(eventTarget, isChecked, query)} />
				}
				rightIconButton={
					<IconButton tooltip="Delete" onClick={() => deleteQuery(query)}>
						<ActionDelete color={red500} />
					</IconButton>}
			/>
    )
  }
}

Query.propTypes = {
  query: PropTypes.string,
	active: PropTypes.bool.isRequired,
	toggleQuery: PropTypes.func.isRequired,
	deleteQuery: PropTypes.func.isRequired
}




// WEBPACK FOOTER //
// ./src/Queries.jsx